import { queryOptions, useQuery } from "@tanstack/react-query";

import { publicApi } from "@blueskydataplatform/shared-ui/lib/api-client";
import type { Dataset } from "@blueskydataplatform/shared-ui/types/datasets.types";
import type { QueryConfig } from "@/lib/react-query";
import { apiPaths } from "@/config/paths";

const getDataset = (id: string, useCase?: "personal" | "commercial"): Promise<{ data: Dataset }> => {
  return publicApi.get(apiPaths.datasets.getDataset.getPath(id), {
    params: { use_case: useCase ?? "commercial" },
  });
};

const getDatasetQueryOptions = ({ id, useCase }: { id: string; useCase?: "personal" | "commercial" }) => {
  return queryOptions({
    queryKey: ["dataset", id, useCase],
    queryFn: () => getDataset(id, useCase),
    select: data => data.data,
  });
};

type UseDatasetOptions = {
  id: string;
  useCase?: "personal" | "commercial";
  queryConfig?: QueryConfig<typeof getDatasetQueryOptions>;
};

export const useDataset = ({ id, useCase, queryConfig }: UseDatasetOptions) => {
  return useQuery({
    ...getDatasetQueryOptions({ id, useCase }),
    ...queryConfig,
  });
};
